import { render } from "./choice.vue?vue&type=template&id=6a3aa75f&scoped=true"
import script from "./choice.vue?vue&type=script&lang=js"
export * from "./choice.vue?vue&type=script&lang=js"

import "./choice.vue?vue&type=style&index=0&id=6a3aa75f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3aa75f"]])

export default __exports__